import { Car } from '@/core/domain/cars/models/cars-data.model';
import { Cars } from '@/core/domain/cars/models/cars.model';
import { GetMoreCarsUseCase } from '@/core/domain/cars/usecases/getMoreCars.usecase';
import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'fe-additional-categories-services',
    templateUrl: './additional-categories-services.component.html',
    styleUrls: ['./additional-categories-services.component.scss'],
})
export class AdditionalCategoriesServicesComponent implements OnInit {
    cars?: Cars;
    flattenedCars?: Car[];
    filteredCars?: Car[];

    selectedCategories: Set<string> = new Set();

    constructor(private getMoreCarsUseCase: GetMoreCarsUseCase) {}

    ngOnInit(): void {
        this.getMoreCars();
    }

    public getMoreCars(): void {
        this.getMoreCarsUseCase.execute().subscribe((cars) => {
            this.cars = cars;

            if (this.cars?.data?.category) {
                this.flattenedCars = this.cars.data.category.flatMap(
                    (category) => category.cars,
                );
                this.filteredCars = [...this.flattenedCars];
            }
        });
    }

    public onFilterChange(event: Event, category: string): void {
        const target = event.target as HTMLInputElement;
        if (target) {
            const isChecked = target.checked;
            if (isChecked) {
                this.selectedCategories.add(category);
            } else {
                this.selectedCategories.delete(category);
            }
            this.applyFilters();
        }
    }

    private applyFilters(): void {
        if (this.flattenedCars) {
            if (this.selectedCategories.size === 0) {
                this.filteredCars = [...this.flattenedCars];
            } else {
                this.filteredCars = this.flattenedCars.filter((car) => {
                    return this.cars?.data?.category.some(
                        (cat) =>
                            this.selectedCategories.has(cat.type) &&
                            cat.cars.includes(car),
                    );
                });
            }
        }
    }
}
